<template>
    <div></div>
</template>

<script>

export default {
    components: {},
    data() {
        return {
            
        }
    },
    watch: {},
    mounted() {
        
    },
    methods: {
        
    }
}
</script>
<style lang='less' scoped>

</style>